'use strict';
var runInChildProcess = false;
var inBrowser = true;
if (typeof window === 'undefined') {
  // by default algos are run in child process, can be changed by env variable below
  runInChildProcess = process.env.RUN_DIGITS_DETECTION_IN_SAME_PROCESS ? false : true;
  inBrowser = false;
}
// create processes
var path = require('path');
var Q = require('q');
var digitReader = require('@smartvatten/digitreader').getDigitReader({runInChildProcess:runInChildProcess});
var digitReader2 = require('@smartvatten/digitreader2').getDigitReader({runInChildProcess:runInChildProcess});
var debug = require('debug')('algorithm:general');
var debugDigitreaderResult = require('debug')('algorithm:digitreader-result');
var debugDigitreader2Result = require('debug')('algorithm:digitreader2-result');
var debugDigitreaderValue = require('debug')('algorithm:digitreader-value');
var debugDigitreader2Value = require('debug')('algorithm:digitreader2-value');
//var debug = require('debug')('algorithm:digitreader2-value');

module.exports.setLogger = function(logger) {
  debug = logger('algorithm:general');
  debugDigitreaderResult = logger('algorithm:digitreader-result');
  debugDigitreader2Result = logger('algorithm:digitreader2-result');
  debugDigitreaderValue = logger('algorithm:digitreader-value');
  debugDigitreader2Value = logger('algorithm:digitreader2-value');
}

var digitsIncrementChecker = require('./digits-increment-checker');

var digitReaderAnalyzeImage = function(pixels, config, debugImage){
  return Q.Promise(function(resolve, reject) {
    digitReader.analyzeImage(pixels, config, function(err, result){
      if (err) reject(err);
      else resolve(result);
    }, debugImage)
  });
}

var digitReader2AnalyzeImage = function(pixels, config){
  return Q.Promise(function(resolve, reject) {
    digitReader2.analyzeImage(pixels, config, function(err, result){
      if (err) reject(err);
      else resolve(result);
    })
  });
}

var getReliability = function(res1, res2) {
  var reliability1 = 0;
  var reliability2 = 0;

  if (res1 >= 0) {
    if (res1 == 6 || res1 == 8 || res1 == 9) {
      reliability1 = 20;
    } else {
      reliability1 = 25;
    }
  }
  if (res2 >= 0) {
    if (res2 == 6 || res2 == 8 || res2 == 9) {
      reliability2 = 20;
    } else {
      reliability2 = 25;
    }
  }

  if (res1 >= 0 && res2 >= 0 && res1 != res2) {
    reliability1 = 0;
    reliability2 = 0;
  }

  return reliability1 + reliability2;
}

// export for unit testing purpose
module.exports.getReliability = getReliability;

// this was initial version, not in use at the moment, more advanced version comes from digitreader2
var buildCombinedResult = function(res1, res2) {
  //console.log(res1, res2)
  for (var i = 0; i < res1.digits.length; i++) {
    res1.digits[i].offset = res2.digits[i].offset;
    if (res1.digits[i].offset === undefined) { res1.digits[i].offset = -1 }
    digitsIncrementChecker.CheckAllowIncrement(res1.digits[i].precision, res1.digits[i].offset);
    // reliability needs to be calculated before res1 is modified
    res1.digits[i].reliability = getReliability(res1.digits[i].result, res2.digits[i].result)
    if (res1.digits[i].precision == 1 || res1.digits[i].precision == 0.1) {
      //console.log('not else', res1.digits[i]);
      if (res1.digits[i].result >= 0 && res2.digits[i].result >= 0 && res1.digits[i].result != res2.digits[i].result) {
        res1.digits[i].result = -7;
      } else if (res1.digits[i].result >= 0 && res2.digits[i].result < 0) {
        res1.digits[i].result = -8;
      } else if (res2.digits[i].result >= 0 && res1.digits[i].result < 0) {
        res1.digits[i].result = -9;
      }
    } else { // for other digits than precision 1 or 0.1 accept result from either algorithms
      //console.log('else');
      if (res1.digits[i].result >= 0 && res2.digits[i].result >= 0 && res1.digits[i].result != res2.digits[i].result) {
        res1.digits[i].result = -7;
      } else if (res1.digits[i].result >= 0) {
        res1.digits[i].result = res1.digits[i].result;
      } else if (res2.digits[i].result >= 0) {
        res1.digits[i].result = res2.digits[i].result;
      }
    }
    if (res1.digits[i].result >= 0 && digitsIncrementChecker.getLatestResult(res1.digits[i].precision) >= 0) {
      if (!digitsIncrementChecker.isIncrementAllowed(res1.digits[i].precision)
        && res1.digits[i].result != digitsIncrementChecker.getLatestResult(res1.digits[i].precision)) {
        res1.digits[i].result = -6;
      }
    }
    if (res1.digits[i].result >= 0) { digitsIncrementChecker.setLatestResult(res1.digits[i].precision, res1.digits[i].result) }

  }
  return res1;
}

// export for unit testing purpose
module.exports.buildCombinedResult = buildCombinedResult;

var getSimpleResult = function(res) {
  var str = "";
  for (var i=0;i<res.digits.length;i++) {
    if(res.digits[i].result < 0) {
      str += '_' + ",";
    }else {
      str += res.digits[i].result + ",";
    }

  }
  return str;
}

module.exports.analyzeImage = function (pixels, config, callback, debugImage) {
  Q.all([
    digitReaderAnalyzeImage(pixels, config, debugImage),
    digitReader2AnalyzeImage(pixels, config)
  ]).then(function(resultArray){
    var res1 = resultArray[0], res2 = resultArray[1];
    debugDigitreaderResult(res1);
    debugDigitreader2Result(res2);
    debugDigitreaderValue(getSimpleResult(res1));
    debugDigitreader2Value(getSimpleResult(res2));
    var res = buildCombinedResult(res1, res2);
    debug(getSimpleResult(res));
    callback(null, res);
  }).catch(function(resultArray) {
    callback(resultArray)
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/digit-reader-combined.js
// module id = 840
// module chunks = 0